"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "StarFilled___StyledSvg",
  componentId: "qfh2q1-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var StarFilled = function StarFilled(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M366.003 449.996a20.983 20.983 0 01-11.655-3.536L240 370.058 125.652 446.46a20.977 20.977 0 01-24.046-.505c-7.098-5.199-10.206-14.292-7.79-22.774l38.598-135.44-96.266-96.481c-6.006-5.999-7.791-15.07-4.557-22.942 3.234-7.85 10.92-12.986 19.404-12.986H164.02l57.206-114.645c7.119-14.25 30.45-14.25 37.57 0L316 155.332h113.004c8.484 0 16.17 5.136 19.404 12.986 3.234 7.872 1.45 16.943-4.557 22.942l-96.266 96.481 38.599 135.44c2.415 8.482-.693 17.575-7.791 22.774a21.005 21.005 0 01-12.39 4.04z"
  }));
};

var _default = StarFilled;
exports["default"] = _default;